import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
import CustomCreateable from "./CustomCreateable";
import { useForm } from "react-hook-form";
import { getGeneralFrequencies, getMedicines } from "./Services";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import TableDropDownField from "../../../common/components/FormFields/TableDropDownField";
import RadioField from "../../../common/components/FormFields/RadioField";
import { DeleteIcon } from "../../../assets/CommonAssets";
import CommonButton from "../../../common/components/Buttons/CommonButton";

const defaultMedication = {
  Medicine: null,
  Frequency: null,
  ison: "",
  Generic: "",
  isNew: false,
  isDelete: false,
};
const isonArray = [
  { id: "On", value: "On", label: "On" },
  { id: "Off", value: "Off", label: "Off" },
];
const OldMedicationModal = (props) => {
  const {
    openOldMedicationsModal,
    setOpenOldMedicationsModal,
    oldMedicationsList,
    setOldMedicationsList,
  } = props;
  const [searchMedicines, setSearchMedicines] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [currentOldMedicationsList, setCurrentOldMedicationsList] = useState(
    []
  );

  const { control, setValue, watch, register } = useForm();

  const handleGetMedicine = (search) => {
    if (search !== "" && UseCheckConsecutiveCharacters(search)) {
      getMedicines(search).then((response) => {
        setSearchMedicines(response.data.result);
      });
    } else {
      setSearchMedicines([]);
    }
  };

  const renderInput = (row, index, header) => {
    setValue(`medicine${index}`, row?.Medicine);
    setValue(`frequency${index}`, row?.Frequency);
    setValue(`ison${index}`, row?.ison);
    return (
      <div>
        {header === "Medicine" && (
          <div className="w-60">
            <CustomCreateable
              menuPlacement={"bottom"}
              width={"250px"}
              control={control}
              name={`medicine${index}`}
              placeholder={"Medicine"}
              handleInputChange={handleGetMedicine}
              dataArray={searchMedicines}
              isSearchable={true}
              inputRef={{
                ...register(`medicine${index}`, {
                  onChange: (e) => {
                    if (e.target.value) {
                      let NewMedicine = {
                        id: e.target.value?.__isNew__
                          ? null
                          : e.target.value?.id,
                        label: e.target.value?.label,
                        value: e.target.value?.__isNew__
                          ? null
                          : e.target.value?.id,
                      };
                      let NewGenericName = {
                        id: e.target.value.genericId,
                        value: e.target.value.genericName,
                        label: e.target.value.genericName,
                      };

                      let dataArray = [...currentOldMedicationsList];
                      dataArray[index] = {
                        ...dataArray[index],
                        Medicine: NewMedicine,
                        Frequency: null,
                        ison: "On",
                        Generic: NewGenericName,
                        isNew: true,
                        isDelete: false,
                      };
                      if (index === dataArray.length - 1) {
                        dataArray.push({ ...defaultMedication });
                      }
                      setCurrentOldMedicationsList(dataArray);
                    }
                  },
                }),
              }}
            />
          </div>
        )}
        {header === "Frequency" && (
          <div className="w-60">
            <TableDropDownField
              menuPlacement={"bottom"}
              width={"250px"}
              control={control}
              name={`frequency${index}`}
              placeholder={"Frequency"}
              dataArray={frequencyOptions}
              isSearchable={true}
              inputRef={{
                ...register(`frequency${index}`, {
                  onChange: (e) => {
                    if (e.target.value !== null) {
                      let Frequency = {
                        id: e.target.value?.id,
                        label: e.target.value?.label,
                        value: e.target.value?.id,
                      };
                      let dataArray = [...currentOldMedicationsList];
                      dataArray[index].Frequency = Frequency;
                      setCurrentOldMedicationsList(dataArray);
                    }
                  },
                }),
              }}
            />
          </div>
        )}
        {header === "ison" && (
          <fieldset className="whitespace-nowrap w-40">
            <RadioField
              control={control}
              name={`ison${index}`}
              dataArray={isonArray}
              onChange={(e) => {
                console.log("eeeeeeeee321", e?.target?.value);
                let dataArray = [...currentOldMedicationsList];
                dataArray[index].ison = e?.target?.value;
                setCurrentOldMedicationsList(dataArray);
              }}
            />
          </fieldset>
        )}
        {header === "Generic" && <div className="">{row?.Generic?.label}</div>}
      </div>
    );
  };

  const renderActions = (row, index) => {
    return (
      <div>
        {row?.Medicine !== null ? (
          <button
            type="button"
            onClick={() => {
              let dataArray = [...currentOldMedicationsList];
              if (row?.isNew === true) {
                dataArray?.splice(index, 1);
              } else if (row?.isNew === false) {
                dataArray[index].isDelete = true;
              }
              setCurrentOldMedicationsList(dataArray);
            }}
          >
            <DeleteIcon />
          </button>
        ) : null}
      </div>
    );
  };

  useEffect(() => {
    if (
      oldMedicationsList?.length > 0 &&
      oldMedicationsList?.some((val) => val?.Medicine === null)
    ) {
      setCurrentOldMedicationsList(oldMedicationsList);
    } else {
      setCurrentOldMedicationsList([
        ...oldMedicationsList,
        { ...defaultMedication },
      ]);
    }

    getGeneralFrequencies(0)
      .then((response) => response.data)
      .then((res) => {
        setFrequencyOptions(res?.result);
      });
  }, []);

  console.log("oldMedicationsList", oldMedicationsList);

  return (
    <Modal open={openOldMedicationsModal}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "80%",
          minHeight: "50%",
          maxHeight: "80%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          border: "1px solid gray",
          boxShadow: 20,
          overflowY: "auto",
          p: 1,
        }}
      >
        <div className="flex justify-between">
          <label className="text-lg font-semibold">Old Medications</label>
          <button
            type="button"
            onClick={() => {
              setOpenOldMedicationsModal(false);
            }}
          >
            <CancelPresentationIconButton />
          </button>
        </div>
        <div>
          {currentOldMedicationsList?.length > 0 ? (
            <CommonDynamicTableNew
              dataResult={currentOldMedicationsList?.filter(
                (val) => val?.isDelete === false
              )}
              renderInput={renderInput}
              renderActions={renderActions}
              editableColumns={["Medicine", "Frequency", "ison", "Generic"]}
              highlightRow={false}
              tableClass={"h-96"}
              removeHeaders={["isNew", "isDelete", "id"]}
            />
          ) : null}
        </div>
        <div className="flex space-x-2 justify-end">
          <CommonButton
            type="button"
            label="Reset"
            className="border border-customRed text-customRed"
            onClick={() => {
              setCurrentOldMedicationsList([
                ...oldMedicationsList,
                { ...defaultMedication },
              ]);
            }}
          />
          <CommonButton
            type="button"
            label="Save & Close"
            className="bg-customGreen text-white"
            onClick={() => {
              setOpenOldMedicationsModal(false);
              setOldMedicationsList(currentOldMedicationsList);
            }}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default OldMedicationModal;
